import Tag from '../../common/Tag/Tag';
import './ProductCard.scss';
import { useEffect, useState } from 'react';
import { Icon } from '../../icon/icon';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Popover } from 'antd';
import { capitalize } from 'lodash';
import { convertCodeToName } from '../../../utils/string/string.utils';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart } from '../../../store/actions/room.action';
import { openMessageWarning } from '../../common/Message/openMessageWarning';
import { openMessageSuccess } from '../../common/Message/openMessageSuccess';
import { getValueFromString } from '../../../utils/data/getValue.utils';
// import { openDrawerCart } from '../../../pages/CartPage/components/DrawerCart/DrawerCart';
import ButtonTertiaryLarge from '../../common/ButtonTertiary/ButtonTertiaryLarge';
import { cn } from '../../../utils/string/cn.utils';
import useDrawerCard from '../../../pages/CartPage/components/DrawerCart/DrawerCart';
import { convertForeignCurrency } from '../../../utils/currency/currency.utils';

const ProductCard = ({ item, style, className, tags, ...props }) => {
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const { t, i18n } = useTranslation();
  const [images, setImages] = useState([]);
  const dispatch = useDispatch();
  const { openDrawerCart } = useDrawerCard();

  const { accessToken } = useSelector(state => state.auth);

  const loadImage = () => {
    const img = images.find(image => image.actived);
    const index = images.findIndex(image => image.actived);
    if (img) {
      return (
        <img
          src={img.src}
          alt=""
          className={cn(
            'object-cover rounded-[2px] transition-all duration-200 ease-in-out w-full'
            // index === 0 ? 'hover:blur-sm' : 'blur hover:blur-none'
          )}
          onMouseOver={e => {
            e.preventDefault();
            setTimeout(() => {
              setImages(prev => {
                const temp = [...prev];
                if (temp.length > 1) {
                  temp[0].actived = false;
                  temp[1].actived = true;
                }
                return temp;
              });
            }, 100);
          }}
          onMouseLeave={e => {
            e.preventDefault();
            setTimeout(() => {
              setImages(prev => {
                const temp = [...prev];
                if (temp.length > 1) {
                  temp[0].actived = true;
                  temp[1].actived = false;
                }
                return temp;
              });
            }, 100);
          }}
        />
      );
    }
    return (
      <div className="grow self-stretch rounded-[2px] overflow-hidden">
        <Icon.ICImagePlaceholder />
      </div>
    );
  };
  useEffect(() => {
    if (item?.images) {
      const temps = [
        ...(item?.images?.map(img => ({ ...img, actived: false })) ?? []),
      ];
      if (temps.length) temps[0].actived = true;
      setImages([...temps]);
    }
  }, [item]);

  return (
    <div
      {...props}
      className={cn(
        'flex w-[354.5px] flex-col items-start rounded-[16px] bg-fills-white',
        className
      )}
      style={style}
      onClick={() => props.onClick?.()}
    >
      {/** Image */}
      <div className="flex h-[354.5px] p-[12px] justify-center items-center gap-[8px] self-stretch relative">
        <div
          className="flex self-stretch grow items-center justify-center overflow-hidden"
          // onClick={e => e.preventDefault()}
        >
          {loadImage()}
        </div>
        <div className="flex flex-col justify-end items-start gap-[8px] absolute left-[12px] bottom-[12.5px]">
          <div className="flex gap-[2px] items-center justify-start">
            {tags?.map((item, index) => (
              <Tag
                key={index}
                label={
                  <span className="text-label-medium font-semibold text-black-high">
                    {item.label}
                  </span>
                }
                className={item.className}
              />
            ))}
          </div>
          {item?.sale_type === 'design' && (
            <Tag
              label={
                <div className="flex items-center justify-start gap-[6px]">
                  <span className="w-[14px] h-[14px] flex">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <path
                        d="M6.41667 11.3306V7.33477L2.91667 5.30768V9.30352L6.41667 11.3306ZM7.58333 11.3306L11.0833 9.30352V5.30768L7.58333 7.33477V11.3306ZM7 6.32852L10.4563 4.3306L7 2.33268L3.54375 4.3306L7 6.32852ZM2.33333 10.3243C2.14861 10.2174 2.00521 10.0764 1.90313 9.90143C1.80104 9.72643 1.75 9.53199 1.75 9.3181V4.6806C1.75 4.46671 1.80104 4.27227 1.90313 4.09727C2.00521 3.92227 2.14861 3.78129 2.33333 3.67435L6.41667 1.32643C6.60139 1.21949 6.79583 1.16602 7 1.16602C7.20417 1.16602 7.39861 1.21949 7.58333 1.32643L11.6667 3.67435C11.8514 3.78129 11.9948 3.92227 12.0969 4.09727C12.199 4.27227 12.25 4.46671 12.25 4.6806V9.3181C12.25 9.53199 12.199 9.72643 12.0969 9.90143C11.9948 10.0764 11.8514 10.2174 11.6667 10.3243L7.58333 12.6723C7.39861 12.7792 7.20417 12.8327 7 12.8327C6.79583 12.8327 6.60139 12.7792 6.41667 12.6723L2.33333 10.3243Z"
                        fill="url(#paint0_linear_10034_17788)"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_10034_17788"
                          x1="1.85642"
                          y1="1.28633"
                          x2="12.1524"
                          y2="1.75093"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#E06161" />
                          <stop offset="0.326923" stop-color="#EBAF4D" />
                          <stop offset="0.528846" stop-color="#DDD155" />
                          <stop offset="0.764423" stop-color="#5FE077" />
                          <stop offset="0.985577" stop-color="#649FD7" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </span>
                  <span className="text-label-medium font-semibold text-black-high ">
                    {t('Customize with the application')}
                  </span>
                </div>
              }
              className={'bg-fills-primary py-[4px] px-[6px] rounded-[4px]'}
            />
          )}
        </div>
      </div>
      {/** Title */}
      <div className="flex min-h-[48px] py-[4px] px-[16px] flex-col items-start gap-[2px] self-stretch">
        {/* <div className="flex flex-row items-start gap-[8px] self-stretch h-[24px]">
          {images
            .filter((_, i) => i < 5)
            .map((img, i) => {
              return (
                <div
                  key={i}
                  className="preview-card w-[24px] h-[24px] p-[2px] flex-col justify-center items-center rounded-[2px]"
                >
                  <Image
                    src={img.src}
                    alt=""
                    className="w-full h-full rounded-[2px]"
                  />
                </div>
              );
            })}

          <span className="text-body-small" style={{ color: '#818589' }}>
            {images.length - 5 > 0 ? '+' + (images.length - 5) : ''}
          </span>
        </div> */}
        {(() => {
          // ...existing code...
          return (
            <Popover
              getPopupContainer={() => document.body}
              classNames={{
                body: 'py-4 px-6',
              }}
              content={
                <span className="text-title-small !font-bold text-black-high">
                  {getValueFromString(item?.name)}
                </span>
              }
            >
              <span className="text-title-small !font-bold text-black-high truncate self-stretch">
                {getValueFromString(item?.name)}
              </span>
            </Popover>
          );
        })()}
      </div>
      <div className="flex py-[4px] px-[16px] flex-col items-start self-stretch gap-[4px] h-[66.5px] overflow-auto">
        {Array.isArray(item?.sizes) ? (
          item?.sizes?.map((size, i) => (
            <div key={i} className="flex items-start gap-[24px] self-stretch">
              <span className="text-body-small w-68 truncate text-black-medium">
                {t(capitalize(convertCodeToName(size.name)))}
              </span>
              <span className="text-body-small font-semibold text-black-high">
                {size.value} mm
              </span>
            </div>
          ))
        ) : item?.sizes ? (
          Object.entries(item?.sizes)?.map(([key, value], index) => (
            <div
              key={index}
              className="flex items-start gap-[24px] self-stretch"
            >
              <span className="text-body-small w-68 truncate text-black-medium">
                {t(capitalize(convertCodeToName(key)))}
              </span>
              <span className="text-body-small font-semibold text-black-high">
                {value} mm
              </span>
            </div>
          ))
        ) : (
          <></>
        )}
        {!item.sizes?.length ? (
          <span className="text-body-medium w-full flex flex-wrap text-black-medium">
            {item?.description
              ? getValueFromString(item?.description)
              : t('Click to view more information')}
          </span>
        ) : null}

        {/* {(() => {
          try {
            return Object.entries(JSON.parse(item?.item_specifics ?? ''))?.map(
              ([key, value], index) => (
                <div
                  key={index}
                  className="flex items-start gap-[24px] self-stretch"
                >
                  <span className="text-body-small w-68 truncate text-black-medium">
                    {t(capitalize(convertCodeToName(key)))}
                  </span>
                  <span className="text-body-small font-semibold text-black-high">
                    {value}
                  </span>
                </div>
              )
            );
          } catch {
            return (
              <div className="flex items-start gap-[24px] self-stretch">
                <span className="text-body-small w-68 truncate text-black-medium">
                  {t(capitalize(convertCodeToName(item?.item_specifics)))}
                </span>
              </div>
            );
          }
        })()} */}
      </div>
      <div className="flex py-[4px] px-[16px] flex-col items-start gap-[4px] self-stretch">
        <div
          className={cn(
            'flex p-[8px] flex-col justify-center items-start gap-[4px] self-stretch rounded-[8px] ',

            item.priceAfter && item.priceAfter !== item.priceOriginal
              ? 'bg-primary-secondary'
              : 'bg-fills-primary'
          )}
        >
          {item.priceAfter ? (
            <div className="flex items-center gap-[12px]">
              <span className="text-title-medium !font-bold text-black-hight">
                {convertForeignCurrency(item.priceAfter)}
              </span>
              {item?.priceAfter !== item?.priceOriginal && (
                <span className="text-label-large font-semibold text-black-medium line-through">
                  {convertForeignCurrency(item.priceOriginal)}
                </span>
              )}
            </div>
          ) : (
            <span className="text-title-medium !font-bold">
              {t('Constant.Contact for more information')}
            </span>
          )}
        </div>
      </div>
      <div className="flex pt-[4px] px-[16px] pb-[16px] flex-col justify-center items-start gap-[4px] self-stretch">
        {item.sale_type ? (
          <ButtonTertiaryLarge
            title={t('Add to Cart')}
            posIcon={<Icon.ICAddToCart />}
            disabled={!item?.priceAfter}
            onClick={e => {
              e.stopPropagation();
              if (!accessToken) {
                openMessageWarning({
                  content: t('Warning.login_to_add_cart'),
                });
              } else {
                dispatch(addToCart({ designId: item.id })).then(action => {
                  if (action.payload?.data)
                    openMessageSuccess({
                      content: t('Success.added_to_cart'),
                    });
                  openDrawerCart();
                });
              }
            }}
          />
        ) : (
          <span className="h-[40px]"></span>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
